import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/styles';
import { useKeycloak } from '@react-keycloak/web';
import * as authActions from 'app/auth/store/actions';
import VisaoGeralLoading from 'app/main/visao-geral/components/VisaoGeralLoading';
import React from 'react';
import { useDispatch } from 'react-redux';
import { TelaBloqueioStyles } from './styles';

const TelaBloqueio = ({ open, mensagem = '', botaoAdicional, loading, hiddenTitle }) => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();

  const classes = TelaBloqueioStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open={open} onClose={() => {}} fullScreen={fullScreen} fullWidth maxWidth="md">
      <DialogContent>
        {loading ? (
          <VisaoGeralLoading size={50} style={{ minHeight: '400px' }} />
        ) : (
          <>
            <div style={{ float: 'left' }}>
              <img src="assets/images/seguranca.png" alt="periodo_trial_expirado" />
            </div>

            <div>
              <span className={classes.ops}>{!hiddenTitle && 'Ops...'}</span>
              <div className={`${classes.divParagrafo} ${hiddenTitle ? classes.divParagrafoSemTitulo : ''}`}>
                <p className={classes.paragrafo}>{mensagem}</p>
              </div>
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          variant="outlined"
          className={classes.botaoSair}
          disabled={loading}
          onClick={() => {
            dispatch(authActions.logoutUser());
            window.location = keycloak.createLogoutUrl();
          }}
        >
          Sair
        </Button>
        {botaoAdicional && (
          <Button
            type="button"
            variant="outlined"
            className={`${classes.botaoSair} ${classes.botaoAdicional}`}
            disabled={loading}
            onClick={botaoAdicional.onClick}
          >
            {botaoAdicional.label}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default TelaBloqueio;
